export type TabOption = 'activity' | 'note' | 'email' | 'text' | 'call';

export const TAB_ACTIVITY = 'activity';
export const TAB_NOTE = 'note';
export const TAB_EMAIL = 'email';
export const TAB_TEXT = 'text';
export const TAB_CALL = 'call';

export function isFormTabSelected(tab: TabOption | null): boolean {
    return tab !== null && (tab === TAB_NOTE || tab === TAB_ACTIVITY);
}
